import JobBulletList from "./JobBulletList";
import JobGroup from "./JobGroup";

const JobSection = ({ section }) => {
  if (!section) return null;

  return (
    <section className="job-section">
      {section.title && <h4 className="job-section-title">{section.title}</h4>}

      {section.items?.length > 0 && <JobBulletList items={section.items} />}

      {section.groups?.length > 0 && (
        <div className="job-groups">
          {section.groups.map((group, index) => (
            <JobGroup key={`${group.title}-${index}`} group={group} />
          ))}
        </div>
      )}
    </section>
  );
};

export default JobSection;
